import request from './index'
import {
  FragmentInfo,
  TagInfo,
  PublishFragmentRequest,
  UpdateFragmentStatusRequest,
} from '../types'

export const fragmentApi = {
  publish: (data: PublishFragmentRequest) =>
    request.post<FragmentInfo>('/fragment/publish', data),

  getTeamFragments: (
    teamId: number,
    params?: {
      type?: number
      status?: string
      tagId?: number
      onlyArchive?: boolean
    }
  ) => request.get<Array<FragmentInfo>>(`/fragment/team/${teamId}/list`, { params }),

  getDetail: (id: number) => request.get<FragmentInfo>(`/fragment/${id}`),

  recall: (id: number) => request.post<void>(`/fragment/${id}/recall`),

  toggleFavorite: (id: number) => request.post<void>(`/fragment/${id}/favorite`),

  toggleTop: (id: number) => request.post<void>(`/fragment/${id}/top`),

  toggleArchive: (id: number, reason?: string) => request.post<void>(`/fragment/${id}/archive`, { reason }),

  updateStatus: (id: number, data: UpdateFragmentStatusRequest) => request.put<void>(`/fragment/${id}/status`, data),

  getFavoriteList: (teamId?: number) => request.get<Array<FragmentInfo>>('/fragment/favorite/list', { params: { teamId } }),

  getReplyChain: (fragmentId: number) => request.get<Array<FragmentInfo>>(`/fragment/${fragmentId}/reply-chain`),

  getMentionList: () => request.get<Array<FragmentInfo>>('/fragment/mention/list'),

  markMentionRead: (fragmentId: number) => request.post<void>(`/fragment/${fragmentId}/mark-mention-read`),

  searchFragments: (teamId: number, keyword: string) =>
    request.get<Array<FragmentInfo>>('/fragment/search', { params: { teamId, keyword } }),
}

export const uploadApi = {
  uploadImage: (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return request.post<{ imageUrl: string; filename: string }>('/upload/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}

export const tagApi = {
  create: (teamId: number, data: { name: string; color?: string }) =>
    request.post<TagInfo>(`/tag/team/${teamId}/create`, data),

  getTeamTags: (teamId: number) =>
    request.get<Array<TagInfo>>(`/tag/team/${teamId}/list`),

  delete: (id: number) => request.delete<void>(`/tag/${id}`),
}

export const aiApi = {
  generateSummary: (teamId: number) =>
    request.post<import('../types').SummaryInfo>(`/ai/team/${teamId}/summary`),

  generateExtract: (teamId: number, data: { fragmentCount: number }) =>
    request.post<import('../types').AiExtractInfo>(`/ai/team/${teamId}/extract`, data),

  generateReview: (teamId: number, data: { reviewType: string }) =>
    request.post<import('../types').ReviewInfo>(`/ai/team/${teamId}/review`, data),

  getSummaryHistory: (teamId: number) =>
    request.get<Array<import('../types').SummaryInfo>>(`/ai/team/${teamId}/summary/list`),

  getExtractHistory: (teamId: number) =>
    request.get<Array<import('../types').AiExtractInfo>>(`/ai/team/${teamId}/extract/list`),

  getReviewHistory: (teamId: number) =>
    request.get<Array<import('../types').ReviewInfo>>(`/ai/team/${teamId}/review/list`),
}

export const sensitiveWordApi = {
  getList: (category?: string) =>
    request.get<Array<import('../types').SensitiveWordInfo>>('/sensitive-word/list', { params: { category } }),

  add: (data: { word: string; category?: string }) =>
    request.post<import('../types').SensitiveWordInfo>('/sensitive-word/add', data),

  edit: (id: number, data: { word: string; category?: string }) =>
    request.put<import('../types').SensitiveWordInfo>(`/sensitive-word/edit/${id}`, data),

  delete: (id: number) => request.delete<void>(`/sensitive-word/delete/${id}`),

  batchImport: (data: { words: string[] }) =>
    request.post<number>('/sensitive-word/batch-import', data),
}
